import { z } from 'zod';

export const setupIpaPricingResponsibilitiesSchema = z.object({
  cdUsuario: z.number({ required_error: 'Selecione um usuário.' }).positive(),
  userName: z.string().min(1),
  userEmail: z.string().email(),
  categories: z.array(z.string()).min(1, 'Selecione ao menos uma categoria para salvar a atribuição.'),
});

export type SetupIpaPricingResponsibilitiesForm = z.infer<typeof setupIpaPricingResponsibilitiesSchema>;
